module.exports = __webpack_public_path__ + "static/media/chicago.03a3402d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cities/chicago.jpg
// module id = 519
// module chunks = 0